module.exports = __webpack_public_path__ + "media/images/textSelectionSample__dropdown-c454677c4901e64d5037a4ebd9e4c310.png";